export default require('./SpeedControl').default
